import React from 'react'

import { Box, Typography } from '@mui/material'

import Button from '../Button/Button.component'
import EmptyState from '../EmptyState/EmptyState.component'
import Loader from '../Loader/Loader.component'

import images from '../../../assets/images'
import styles from './PaymentSubmittedSuccessfully.styles'
import { AdditionalInfoSection, PaymentSubmittedSuccessfullyProps } from './PaymentSubmittedSuccessfully.types'

const { OrderSubmittedCheckmarkIcon } = images

export const PaymentSubmittedSuccessfully: React.FC<PaymentSubmittedSuccessfullyProps> = (props) => {
  const {
    title,
    description,
    button,
    secondaryButton,
    loadingState,
    success,
    errorState,
    orderReference,
    additionalInfo,
    additionalInfoTitle,
    labelingInstructions,
    warehouseInfo
  } = props

  // Convert legacy warehouseInfo to additionalInfo format for backward compatibility
  const infoSections: AdditionalInfoSection[] = additionalInfo || []

  if (warehouseInfo && !additionalInfo) {
    if (warehouseInfo.warehouseAddress) {
      infoSections.push({ label: 'Warehouse Address:', value: warehouseInfo.warehouseAddress })
    }
    if (warehouseInfo.dropoffInstructions) {
      infoSections.push({ label: 'Dropoff Instructions:', value: warehouseInfo.dropoffInstructions })
    }
  }

  if (loadingState.loading) {
    return <Loader loading={loadingState.loading} text={loadingState.text} size="large" marginTop={10} />
  } else if (success) {
    return (
      <Box sx={styles.container}>
        <Box sx={styles.iconContainer}>
          <OrderSubmittedCheckmarkIcon style={styles.icon} />
        </Box>

        <Typography sx={styles.title}>{title}</Typography>

        <Typography sx={styles.description}>{description}</Typography>

        {orderReference && (
          <Box sx={styles.orderReferenceRow}>
            <Typography sx={styles.orderReferenceLabel}>Order Reference:</Typography>
            <Typography sx={styles.orderReferenceValue}>{orderReference}</Typography>
          </Box>
        )}

        {labelingInstructions && orderReference && (
          <Box sx={styles.labelingInstructions}>
            <Typography sx={styles.labelingTitle}>Print & Attach to Package</Typography>

            <Typography sx={styles.labelingIntro}>
              Please print the details below and attach them visibly to your package before drop-off.
            </Typography>

            <Box sx={styles.labelingSection}>
              <Typography sx={styles.labelingLabel}>Order Reference:</Typography>
              <Typography sx={styles.labelingValue}>{orderReference}</Typography>
            </Box>

            <Box sx={styles.labelingSection}>
              <Typography sx={styles.labelingLabel}>Recipient Name:</Typography>
              <Typography sx={styles.labelingValue}>{labelingInstructions.recipientName}</Typography>
            </Box>

            <Box sx={styles.labelingSection}>
              <Typography sx={styles.labelingLabel}>Recipient Address:</Typography>

              <Typography sx={styles.labelingAddressValue}>
                {labelingInstructions.recipientAddressLines.join('\n')}
              </Typography>
            </Box>
          </Box>
        )}

        {infoSections.length > 0 && (
          <Box sx={styles.warehouseInfo}>
            {additionalInfoTitle && <Typography sx={styles.warehouseTitle}>{additionalInfoTitle}</Typography>}

            {infoSections.map((section, sectionIndex) => (
              <Box key={sectionIndex} sx={styles.warehouseSection}>
                <Typography sx={styles.warehouseLabel}>{section.label}</Typography>
                <Typography sx={styles.warehouseText}>{section.value}</Typography>
              </Box>
            ))}
          </Box>
        )}

        <Box sx={styles.buttonContainer}>
          <Button {...button} />
          {secondaryButton && <Button {...secondaryButton} />}
        </Box>
      </Box>
    )
  } else if (errorState) {
    return <EmptyState {...errorState} marginTop={10} />
  } else {
    return null
  }
}
